import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { Modal } from 'react-bootstrap'

import { httpOk, GET, PUT } from 'helpers/api'

// Tizim rollarining o'zbekcha nomi va ikonkasi
const ROLE_META = {
	ROLE_CASHIER: { label: 'Kassir', icon: 'uil-shop', desc: 'Kassa, chek, savdo' },
	ROLE_WORKSHOP: { label: "Sex / Bo'lim rahbari", icon: 'uil-constructor', desc: 'Zakaz, status, ishlab chiqarish' },
	ROLE_DIRECTOR: { label: 'Direktor', icon: 'uil-user-square', desc: 'Hisobotlar, boshqaruv' },
	ROLE_COURIER: { label: 'Kuryer', icon: 'uil-truck', desc: 'Yetkazib berish' },
	ROLE_WAREHOUSE: { label: 'Omborchi', icon: 'uil-store', desc: 'Ombor, qabul, hisob' },
}

function Index() {
	const { t } = useTranslation()

	const [data, setData] = useState([])
	const [permissions, setPermissions] = useState([])
	const [selectedRole, setSelectedRole] = useState({})
	const [showModal, setShowModal] = useState(false)

	async function getRoles() {
		const response = await GET('/roles', {}, { loader: true })
		if (httpOk(response)) setData(response.data)
	}

	async function openEdit(role) {
		setSelectedRole(role)
		const response = await GET('/helper/permissions', { role_id: role.id })
		if (httpOk(response)) {
			setPermissions(response.data)
			setShowModal(true)
		}
	}

	async function save(e) {
		e.preventDefault()

		const collected = []
		for (let i = 0; i < permissions.length; i++) {
			for (let j = 0; j < permissions[i]['permissions'].length; j++) {
				if (permissions[i]['permissions'][j]['checked']) {
					collected.push(permissions[i]['permissions'][j])
				}
			}
		}

		const response = await PUT('/roles', { role_id: selectedRole.id, permissions: collected }, { loader: true })
		if (httpOk(response)) {
			setShowModal(false)
			getRoles()
		}
	}

	function selectAll(checked, catIndex) {
		const copy = [...permissions]
		for (let j = 0; j < copy[catIndex]['permissions'].length; j++) {
			copy[catIndex]['permissions'][j]['checked'] = checked
		}
		copy[catIndex]['checked'] = checked
		setPermissions(copy)
	}

	function selectOne(checked, catIndex, permIndex) {
		const copy = [...permissions]
		copy[catIndex]['permissions'][permIndex]['checked'] = checked
		setPermissions(copy)
	}

	useEffect(() => {
		getRoles()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	function meta(roleName) {
		return ROLE_META[roleName] || { label: roleName, icon: 'uil-user', desc: '' }
	}

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center">Rollar [{data.length}]</h4>
			</div>

			<div className="card">
				<div className="card-body">
					<p className="text-muted small mb-3">
						<i className="uil-info-circle me-1"></i>
						Har bir rol tizimda nima qila olishini shu yerdan sozlaysiz. Xodimga login berganda tanlangan rolning ruxsatlari avtomatik tushadi.
					</p>
					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ minWidth: '33px' }} className="text-center">#</th>
									<th style={{ width: '30%' }}>Rol</th>
									<th>Tavsif</th>
									<th style={{ width: '15%' }} className="text-center">Ruxsatlar</th>
									<th style={{ minWidth: '90px' }} className="text-center">{t('edit')}</th>
								</tr>
							</thead>
							<tbody>
								{data.map((role, index) => {
									const m = meta(role.role_name)
									return (
										<tr key={index} className="tr-middle">
											<td className="text-center">{index + 1}</td>
											<td>
												<div className="d-flex align-items-center gap-2">
													<span className="d-flex align-items-center justify-content-center"
														style={{ width: 34, height: 34, borderRadius: 8, background: '#eef2ff', color: '#4f46e5' }}>
														<i className={m.icon}></i>
													</span>
													<span className="fw-semibold">{m.label}</span>
												</div>
											</td>
											<td className="text-muted">{m.desc}</td>
											<td className="text-center">
												{Number(role.permissions_count) > 0
													? <span className="badge bg-success">{role.permissions_count} ta</span>
													: <span className="badge bg-light text-muted border">yo'q</span>
												}
											</td>
											<td className="text-center">
												<button className="btn btn-sm btn-outline-primary"
													onClick={() => openEdit(role)}>
													<i className="uil-edit-alt me-1"></i>Sozlash
												</button>
											</td>
										</tr>
									)
								})}
							</tbody>
						</table>
					</div>
				</div>
			</div>

			{/* EDIT MODAL */}
			<Modal show={showModal} animation={false} centered size="lg" backdrop="static"
				onHide={() => setShowModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title>
						<i className={`${meta(selectedRole.role_name).icon} me-2`}></i>
						{meta(selectedRole.role_name).label} — ruxsatlar
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={save} autoComplete="off">
						<div style={{ maxHeight: '460px', overflowY: 'auto', border: '1px solid #dee2e6', borderRadius: 4 }}>
							{permissions.map((category, catIndex) => (
								<div key={catIndex}>
									<div className="d-flex justify-content-between align-items-center cursor px-3 py-2"
										style={{ background: '#f8f9fa', borderBottom: '1px solid #dee2e6' }}
										onClick={() => selectAll(!category.checked, catIndex)}>
										<span className="fw-semibold small">{category.name}</span>
										<input type="checkbox" className="form-check-input"
											checked={category.checked || false}
											onChange={(e) => { e.stopPropagation(); selectAll(e.target.checked, catIndex) }} />
									</div>
									{category.permissions.map((perm, permIndex) => (
										<div key={permIndex}
											className="d-flex justify-content-between align-items-center cursor px-3 py-1"
											style={{ borderBottom: '1px solid #f5f5f5' }}
											onClick={() => selectOne(!perm.checked, catIndex, permIndex)}>
											<span className="small" style={{ paddingLeft: perm.parent_id ? 16 : 0 }}>{perm.name_ru}</span>
											<input type="checkbox" className="form-check-input"
												checked={perm.checked || false}
												onChange={(e) => { e.stopPropagation(); selectOne(e.target.checked, catIndex, permIndex) }} />
										</div>
									))}
								</div>
							))}
							{permissions.length === 0 &&
								<div className="text-muted small p-3">{t('list_empty')}</div>
							}
						</div>

						<div className="d-flex gap-2 w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100"
								onClick={() => setShowModal(false)}>{t('cancel')}</button>
							<button type="submit" className="btn btn-primary w-100">{t('save')}</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
		</>
	)
}

export default Index
